import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Field,
  FieldArray,
  FormSection,
  reduxForm,
  formValueSelector,
  arrayRemoveAll,
} from 'redux-form'
import { TextField, SelectField } from 'redux-form-material-ui'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'
import { AutoComplete as MUIAutoComplete } from 'material-ui'
import CategoryFields from './CategoryFields'
import MultiImages from '../MultiImages'
import GenereAutoComplete from './GenereAutoComplete'
import ImageField from '../ImageField'
import { required, money } from '../../form/validation'
import { getObjectConditions, shouldShowGenereFilter } from '../../utils'
import LinearLoader from '../../common/LinearLoader'

class InsertItemForm extends PureComponent {
  componentWillReceiveProps(nextProps) {
    if (nextProps.currentCategory !== this.props.currentCategory) {
      this.props.arrayRemoveAll('add-item-form', 'attributi')
      // this.props.untouch('add-item-form', 'attributi[0].AUTORE')
    }
  }

  componentWillUnmount() {
    this.props.arrayRemoveAll('add-item-form', 'attributi')
    // this.props.untouch('add-item-form', 'attributi')
  }

  render() {
    const {
      handleSubmit,
      submitting,
      currentCategory,
      interest,
      conditions,
    } = this.props

    const validateImage = interest ? [] : [required]

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name="titolo"
          hintText="Titolo *"
          floatingLabelText="Titolo *"
          fullWidth={true}
          validate={required}
          component={TextField}
        />

        <Field
          name="immagine"
          validate={validateImage}
          component={ImageField}
        />

        {shouldShowGenereFilter(currentCategory) &&
          <Field
            maxSearchResults={5}
            validate={[required]}
            name={'genere'}
            hintText={'Genere *'}
            floatingLabelText={'Genere *'}
            fullWidth={true}
            categoryId={currentCategory.id}
            filter={MUIAutoComplete.caseInsensitiveFilter}
            component={GenereAutoComplete}
          />}

        {/* TODO: Use form_interesse for interest when will be sbugged  */}
        <FormSection name="attributi">
          <CategoryFields
            filterBy={interest ? 'form' : 'form'}
            category={currentCategory}
          />
        </FormSection>

        {!interest &&
          <div>
            <Field
              name="condizioni"
              component={SelectField}
              fullWidth={true}
              hintText={
                currentCategory.id === 50
                  ? 'Condizioni Disco *'
                  : 'Condizioni *'
              }
              floatingLabelText={
                currentCategory.id === 50
                  ? 'Condizioni Disco *'
                  : 'Condizioni *'
              }
              validate={required}>
              {conditions.map(({ value, label }) => (
                <MenuItem value={value} primaryText={label} key={value} />
              ))}
            </Field>

            {currentCategory.id === 50 &&
              <div>
                <Field
                  name="condizioni2"
                  component={SelectField}
                  fullWidth={true}
                  hintText="Condizioni Copertina *"
                  floatingLabelText="Condizioni Copertina *"
                  validate={required}>
                  {conditions.map(({ value, label }) => (
                    <MenuItem value={value} primaryText={label} key={value} />
                  ))}
                </Field>
              </div>}

            <Field
              name="valore"
              component={TextField}
              validate={[required, money]}
              hintText="Valore € *"
              floatingLabelText="Valore € *"
              fullWidth={true}
            />
            <Field
              name="descrizione"
              component={TextField}
              hintText="Note"
              floatingLabelText="Note"
              multiLine={true}
              fullWidth={true}
              rows={2}
            />
          </div>}

        {interest &&
          <Field
            name="note"
            component={TextField}
            hintText="Note"
            floatingLabelText="Note"
            multiLine={true}
            fullWidth={true}
            rows={2}
          />}

        {!interest &&
          <div style={{ marginTop: 10 }}>
            <FieldArray name="altre_immagini" component={MultiImages} />
          </div>}
        <div style={{ display: 'flex' }}>
          <div style={{ marginTop: 40, marginLeft: 'auto' }}>
            <RaisedButton
              disabled={submitting}
              type="submit"
              primary={true}
              label="Salva"
            />
          </div>
        </div>
        {submitting && <LinearLoader />}
      </form>
    )
  }
}

const selector = formValueSelector('add-item-form')

const mapStateToProps = state => {
  const currentCategory = selector(state, 'category')

  return {
    currentCategory,
    conditions: getObjectConditions(currentCategory.id),
  }
}

export default reduxForm({
  form: 'add-item-form',
  forceUnregisterOnUnmount: true,
  destroyOnUnmount: false,
})(
  connect(mapStateToProps, {
    arrayRemoveAll,
  })(InsertItemForm)
)



// WEBPACK FOOTER //
// ./src/common/AddItemForm/InsertItemForm.js